/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/ 
var styles = [".alertContainer[_ngcontent-%COMP%] {\n  height: auto;\n  width: auto; }\n\n.msgContainer[_ngcontent-%COMP%] {\n  margin-bottom: 0.5em; }"];
export { styles as styles };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/alertComponent/alert.style.scss.shim.ngstyle.js.pre-build-optimizer.js